export enum TRACK_TYPES {
  AUDIO = "audio",
  VIDEO = "video",
}

export enum CRATE_TYPES {
  TRACK = "track",
  RELEASE = "release",
  PLAYLIST = "playlist",
}

export enum ENUM_TYPE_REQUEST {
  DOWNLOAD = "download",
}

export enum IMPORT_STATUS {
  SUCCESS = 'success',
  WARNING = 'warning'
}